import { MapConfigTypeToConfigKeyMap } from '@nova/configs';
import { EGameConfigs } from '@nova/types';

import { axiosHttp } from '../axios-http';

/** Server-side / MMS: unauthenticated `axiosHttp` (browser game API uses `GameApiHttp` elsewhere). */
export async function fetchCombatGameMaps(gameAPIEndpoint: string): Promise<MapConfigTypeToConfigKeyMap> {
  try {
    const url = `${gameAPIEndpoint}/game-configs/${EGameConfigs.COMBAT_GAME_MAPS}`;
    const mapsFetchObj = await axiosHttp.get(url);
    return mapsFetchObj.data as MapConfigTypeToConfigKeyMap;
  }
  catch (reason: unknown) {
    throw new Error(`LobbyMatchPrep::fetchCombatGameMaps error: ${reason}`, { cause: reason });
  }
}
